// Google Analytics utility functions
// gtag is loaded globally via the script tag in index.html

// Get Google Analytics Measurement ID from environment variables
// Set REACT_APP_GA_MEASUREMENT_ID in your .env file
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url, title) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', eventName, {
      event_category: parameters.category || 'engagement',
      event_label: parameters.label,
      value: parameters.value,
      ...parameters,
    });
  }
};

// Security+ app specific tracking functions
export const trackConceptViewed = (conceptKey, conceptTitle) => {
  trackEvent('concept_viewed', {
    category: 'learning',
    label: conceptKey,
    concept_title: conceptTitle,
  });
};

export const trackBookmarkToggle = (conceptKey, isBookmarked) => {
  trackEvent('bookmark_toggle', {
    category: 'engagement', 
    label: conceptKey,
    action: isBookmarked ? 'add' : 'remove',
  });
};

export const trackSearch = (searchTerm, resultsCount) => {
  trackEvent('search', {
    category: 'search',
    label: searchTerm,
    search_term: searchTerm,
    results_count: resultsCount,
  });
};

export const trackStudySession = (sessionDuration, conceptsViewed) => {
  trackEvent('study_session', {
    category: 'learning',
    session_duration_minutes: Math.round(sessionDuration / 60000), // Convert ms to minutes
    concepts_viewed: conceptsViewed,
  });
};

export const trackDomainInteraction = (domainId, domainTitle) => {
  trackEvent('domain_interaction', {
    category: 'navigation',
    label: domainId,
    domain_title: domainTitle,
  });
};